import { render } from "./CustomSelect.vue?vue&type=template&id=676333be&scoped=true"
import script from "./CustomSelect.vue?vue&type=script&lang=js"
export * from "./CustomSelect.vue?vue&type=script&lang=js"

import "./CustomSelect.vue?vue&type=style&index=0&id=676333be&scoped=true&lang=stylus"
script.render = render
script.__scopeId = "data-v-676333be"

export default script